import { BaseIcon } from './base';
import type { IconProps } from './base';

export function IconJobSmall(props: IconProps) {
  return (
    <BaseIcon {...props} size={16} viewBox="0 0 16 16">
      <path
        d="M9.33333 3.99998V2.66665H6.66666V3.99998H9.33333ZM2.66666 5.99998V12C2.66666 12.3666 2.96666 12.6666 3.33333 12.6666H12.6667C13.0333 12.6666 13.3333 12.3666 13.3333 12V5.99998C13.3333 5.63331 13.0333 5.33331 12.6667 5.33331H3.33333C2.96666 5.33331 2.66666 5.63331 2.66666 5.99998ZM13.3333 3.99998C14.0733 3.99998 14.6667 4.59331 14.6667 5.33331V12.6666C14.6667 13.4066 14.0733 14 13.3333 14H2.66666C1.92666 14 1.33333 13.4066 1.33333 12.6666L1.33999 5.33331C1.33999 4.59331 1.92666 3.99998 2.66666 3.99998H5.33333V2.66665C5.33333 1.92665 5.92666 1.33331 6.66666 1.33331H9.33333C10.0733 1.33331 10.6667 1.92665 10.6667 2.66665V3.99998H13.3333Z"
        fill="currentColor"
      />
    </BaseIcon>
  );
}
